// Aervix theme scripts
document.addEventListener('click', function (e) {
  var step = e.target.closest('[data-qty]');
  if (step) {
    var wrap = step.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (input) {
      var v = parseInt(input.value, 10) || 1;
      v = step.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    e.preventDefault();
    return;
  }

  var toggle = e.target.closest('[data-toggle]');
  if (toggle) {
    var target = document.querySelector(toggle.getAttribute('data-toggle'));
    if (target) target.hidden = !target.hidden;
    e.preventDefault();
  }
});

// Variant picker: keep price and availability in sync
document.querySelectorAll('[data-variant-picker]').forEach(function (form) {
  var select = form.querySelector('[name="id"]');
  if (!select) return;
  var dataEl = form.querySelector('[data-variant-json]');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var priceEl = form.querySelector('[data-variant-price]');
  var button = form.querySelector('[data-add-button]');
  select.addEventListener('change', function () {
    var v = variants.filter(function (x) { return String(x.id) === String(select.value); })[0];
    if (!v) return;
    if (priceEl) priceEl.textContent = v.price_formatted;
    if (button) {
      button.disabled = !v.available;
      button.textContent = v.available ? 'Adicionar ao carrinho' : 'Produto esgotado';
    }
  });
});

// Cart quantity inputs submit their form on change
document.querySelectorAll('[data-cart-form] input[name="updates[]"]').forEach(function (input) {
  input.addEventListener('change', function () {
    input.closest('form').submit();
  });
});
